<template>
    <span>
        {{ jobsite.JobsiteName }}
    </span>
</template>

<script>
    export default {
        props: {
            jobsite: {
                type: Object,
                required: true
            }
        },

        data: function() {
            return {

            }
        },

        methods: {


        },

        mounted() {

        }
    }
</script>
